import { fabric } from 'fabric';

/**
 * Shadow Boost filter class
 * Enhances shadows by lifting dark areas while preserving midtones and highlights
 * Useful for recovering detail in underexposed areas or creating dramatic effects
 */
fabric.Image.filters.ShadowBoost = fabric.util.createClass(
  fabric.Image.filters.BaseFilter,
  {
    type: 'ShadowBoost',

    /**
     * Shadow boost intensity, from 0 to 1
     * 0 = no effect
     * 1 = maximum shadow lifting
     */
    shadowBoost: 0,

    /**
     * Fragment shader for WebGL rendering
     * Uses a curve to selectively brighten shadows while preserving highlights
     */
    fragmentSource:
      'precision highp float;\n' +
      'uniform sampler2D uTexture;\n' +
      'uniform float uShadowBoost;\n' +
      'varying vec2 vTexCoord;\n' +
      'void main() {\n' +
      '  vec4 color = texture2D(uTexture, vTexCoord);\n' +
      '  float luminance = dot(color.rgb, vec3(0.299, 0.587, 0.114));\n' +
      // Apply shadow lifting curve - affects dark areas more than bright areas
      '  float shadowMask = 1.0 - luminance;\n' +
      '  shadowMask = shadowMask * shadowMask;\n' + // Square to focus on darker areas
      '  float boost = uShadowBoost * shadowMask * 0.5;\n' +
      // Apply boost to RGB channels
      '  color.rgb = color.rgb + (boost * (1.0 - color.rgb));\n' +
      // Ensure we don't exceed valid range
      '  color.rgb = clamp(color.rgb, 0.0, 1.0);\n' +
      '  gl_FragColor = color;\n' +
      '}',

    /**
     * Apply filter using Canvas 2D API
     */
    applyTo2d: function (options) {
      const imageData = options.imageData;
      const data = imageData.data;
      const shadowBoost = this.shadowBoost;

      for (let i = 0; i < data.length; i += 4) {
        // Calculate luminance
        const r = data[i] / 255;
        const g = data[i + 1] / 255;
        const b = data[i + 2] / 255;
        const luminance = 0.299 * r + 0.587 * g + 0.114 * b;

        // Create shadow mask (affects dark areas more)
        let shadowMask = 1.0 - luminance;
        shadowMask = shadowMask * shadowMask; // Square to focus on darker areas

        // Calculate boost amount
        const boost = shadowBoost * shadowMask * 0.5;

        // Apply boost to each channel (lifting shadows)
        data[i] = Math.min(255, data[i] + boost * (255 - data[i])); // Red
        data[i + 1] = Math.min(255, data[i + 1] + boost * (255 - data[i + 1])); // Green
        data[i + 2] = Math.min(255, data[i + 2] + boost * (255 - data[i + 2])); // Blue
        // Alpha channel (i + 3) remains unchanged
      }
    },

    /**
     * Send uniform data to WebGL shader
     */
    getUniformLocations: function (gl, program) {
      return {
        uShadowBoost: gl.getUniformLocation(program, 'uShadowBoost'),
      };
    },

    /**
     * Send uniform values to WebGL shader
     */
    sendUniformData: function (gl, uniformLocations) {
      gl.uniform1f(uniformLocations.uShadowBoost, this.shadowBoost);
    },

    /**
     * Returns object representation of filter
     */
    toObject: function () {
      return fabric.util.object.extend(this.callSuper('toObject'), {
        shadowBoost: this.shadowBoost,
      });
    },
  }
);

/**
 * Create filter instance from object representation
 */
fabric.Image.filters.ShadowBoost.fromObject =
  fabric.Image.filters.BaseFilter.fromObject;

export default fabric.Image.filters.ShadowBoost;
